import { useState, useEffect } from 'react';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

const BREAKPOINTS = { mobile: 640, tablet: 1024 };

function getBreakpoint(w: number): Breakpoint {
  if (w < BREAKPOINTS.mobile) return 'mobile';
  if (w < BREAKPOINTS.tablet) return 'tablet';
  return 'desktop';
}

export function useBreakpoint() {
  const [bp, setBp] = useState<Breakpoint>(() => getBreakpoint(window.innerWidth));

  useEffect(() => {
    let raf: number;
    const handler = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => setBp(getBreakpoint(window.innerWidth)));
    };
    window.addEventListener('resize', handler);
    return () => { window.removeEventListener('resize', handler); cancelAnimationFrame(raf); };
  }, []);

  return {
    bp,
    isMobile:  bp === 'mobile',
    isTablet:  bp === 'tablet',
    isDesktop: bp === 'desktop',
    isSmall:   bp === 'mobile' || bp === 'tablet',
    /** Responsive value picker: rp({ mobile: X, tablet: Y, desktop: Z }) */
    rp: <T,>(vals: { mobile: T; tablet?: T; desktop: T }): T => {
      if (bp === 'mobile') return vals.mobile;
      if (bp === 'tablet') return vals.tablet ?? vals.desktop;
      return vals.desktop;
    },
  };
}
